module.exports = __webpack_public_path__ + "img/guide12.86e5c770.png";